/* Gerado por scripts/sync-app-version.mjs a partir de package.json — não editar */
export const PLATFORM_APP_VERSION = "4.0.564";
